/** `Document.prerendering` is not yet part of the TypeScript DOM typings in use. */
type PrerenderableDocument = Document & { prerendering?: boolean };

/**
 * Chrome may prerender a page before the user opens it, e.g. while a URL is typed into the address bar.
 * Session storage written while prerendering is discarded on activation, so the deeplink of the welcome page
 * and the Okta sign-in state would be lost and the user would land on the User Journey instead.
 * Resolves at once for a regular page load, otherwise as soon as the prerendered page is shown.
 */
export function whenPageActivated(doc: Document = document): Promise<void> {
  if (!(doc as PrerenderableDocument).prerendering) {
    return Promise.resolve();
  }
  return new Promise(resolve => doc.addEventListener('prerenderingchange', () => resolve(), { once: true }));
}
